import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import * as React from 'react';
import { requestSortApTemplateAction } from '../../../asyncHelpers/actionPlanTemplateService';
import ApEditorMode from '../../../enums/ApEditorMode';
import { ApEditorActions } from '../../../sic-lib/reducers/actionPlanEditorReducer';

interface Props {
    apRootId: number;
    apActionId: number;
    apEditMode: ApEditorMode;
    apActionIndex: number;
    apDispatch: React.Dispatch<ApEditorActions>;
    hasPrevAction: boolean;
    hasNextAction: boolean;
}

export default function ActionReorderButtons({
    apRootId,
    apActionId,
    apEditMode,
    apActionIndex,
    apDispatch,
    hasPrevAction,
    hasNextAction,
}: Props) {
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const handleReorder = async (event: React.MouseEvent<HTMLButtonElement>) => {
        try {
            const { direction } = event.currentTarget.dataset;
            /* 
                Prevent weird UI behaviour if re-order is executed on first/last actions
             */
            if (
                !direction ||
                apEditMode !== ApEditorMode.template ||
                (direction === 'up' && !hasPrevAction) ||
                (direction === 'down' && !hasNextAction)
            ) {
                return;
            }

            await requestSortApTemplateAction(
                apRootId,
                apActionId,
                direction === 'up' ? true : false,
                request_token.token,
            );

            apDispatch({
                type: 'REORDER_EDITOR_ACTION',
                direction: direction as 'up' | 'down',
                actionIndex: apActionIndex,
            });
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                console.log('[ERROR] - handleReorder: ', e);
            }
        }
    };

    return (
        <React.Fragment>
            <Grid container direction="row" wrap="nowrap" spacing={2}>
                <Grid item xs="auto">
                    <Tooltip title="Move up">
                        <IconButton
                            data-direction="up"
                            size="small"
                            disabled={!hasPrevAction}
                            onClick={handleReorder}
                        >
                            <KeyboardArrowUpIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Move down">
                        <IconButton
                            data-direction="down"
                            size="small"
                            disabled={!hasNextAction}
                            onClick={handleReorder}
                        >
                            <KeyboardArrowDownIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
